(() => {
  class ClContentFaq extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.animations = new Map();
      this.handleClick = this.onClick.bind(this);
      this.handleBlockSelect = this.onBlockSelect.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      let hasOpenItem = false;
      this.querySelectorAll('[data-faq-item]').forEach(item => {
        if (item.open && this.dataset.allowMultiple !== 'true') {
          if (hasOpenItem) item.open = false;
          else hasOpenItem = true;
        }
        this.syncAccessibility(item, item.open);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.animations?.forEach((animation, item) => {
        animation.cancel();
        item.open = item.dataset.expanded === 'true';
        item.querySelector('[data-faq-panel]').style.height = '';
      });
      this.animations?.clear();
      this.initialized = false;
    }

    syncAccessibility(item, open) {
      item.dataset.expanded = String(open);
      item.querySelector('summary').setAttribute('aria-expanded', String(open));
      item.querySelector('[data-faq-panel]').inert = !open;
    }

    onClick(event) {
      const summary = event.target.closest('summary');
      const item = summary?.closest('[data-faq-item]');
      if (!item || item.closest('cl-content-faq') !== this) return;
      event.preventDefault();
      this.setOpen(item, item.dataset.expanded !== 'true');
    }

    onBlockSelect(event) {
      const item = event.target.closest('[data-faq-item]');
      if (item && this.contains(item)) this.setOpen(item, true);
    }

    setOpen(item, open) {
      if (item.dataset.expanded === String(open) && !this.animations.has(item)) return;
      if (open && this.dataset.allowMultiple !== 'true') {
        this.querySelectorAll('[data-faq-item][data-expanded="true"]').forEach(other => {
          if (other !== item) this.setOpen(other, false);
        });
      }
      const panel = item.querySelector('[data-faq-panel]');
      const fromHeight = item.open ? panel.getBoundingClientRect().height : 0;
      this.animations.get(item)?.cancel();
      this.animations.delete(item);
      item.open = true;
      panel.style.height = '';
      const toHeight = open ? panel.scrollHeight : 0;
      this.syncAccessibility(item, open);
      const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 0 : Number(this.dataset.duration) || 0;
      const finish = () => {
        item.open = open;
        panel.style.height = '';
        this.animations.delete(item);
      };
      if (!duration || typeof panel.animate !== 'function') {
        finish();
        return;
      }
      const animation = panel.animate(
        [{ height: `${fromHeight}px` }, { height: `${toHeight}px` }],
        { duration, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)', fill: 'both' }
      );
      this.animations.set(item, animation);
      animation.onfinish = () => {
        // Uma interação mais recente pode ter invertido a animação.
        if (this.animations.get(item) !== animation) return;
        finish();
        animation.cancel();
      };
    }
  }

  if (!customElements.get('cl-content-faq')) customElements.define('cl-content-faq', ClContentFaq);
})();
